<template>
    <div style="width:85%;margin:auto;padding-top:10px;color:#7b7c87">
        
        <v-layout row wrap>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;padding-bottom:2px !important"><!--Row #1-->
                <v-layout row wrap>
                    <v-flex xs12 sm12 md10 lg10 xl10 style="padding:15px;padding-bottom:0px;">
                    <div style="padding-top:23px;font-weight:bolder;font-size:20px">مدیریت صفحه تماس با ما</div>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;"><!--Row #2-->
                  <v-card>
                    <v-card-text>
                      <v-layout row wrap>
                          <v-flex xs12 md12 lg12 xl12 style="padding:15px;"><!--Row #2-->
                            <v-layout row wrap style="flex-wrap:wrap-reverse !important;">
                                <v-flex xs12 sm12 md6 lg6 xl6 style="padding:15px;padding-top:0px !important;border-left:1px solid rgb(200,200,200)"><!--Register New Cat From-->
                                    
                                    <quill-editor placeholder="محتوای صفحه" label="محتوای صفحه" :content="EditorContent"
                                    @change="({html})=>{EditorContent = html}">
                                    </quill-editor>

                                    <v-text-field class="mt-5" style="direction:ltr !important" color="#2a2d45" outlined dense v-model="Lat" label="عرض جغرافیایی" ></v-text-field>

                                    <v-text-field style="direction:ltr !important" color="#2a2d45" outlined dense v-model="Lng" label="طول جغرافیایی" ></v-text-field>

                                     <v-text-field v-for="(item,index) in Socials" prepend-icon="fas fa-trash" @click:prepend="Remove(index)" @click:append="Add(index)" append-icon="fas fa-plus" :key="index" style="direction:ltr !important" color="#2a2d45" outlined dense v-model="item.userName" :prefix="item.url" :prepend-inner-icon="'fab '+item.icon" ></v-text-field>
                                    
                                    <v-btn @click="registerCategory" outlined dark block color="blue"><v-icon small style="padding-left:5px;">fa fa-check</v-icon>&nbsp; ذخیره</v-btn>
                              
                                </v-flex>
                                <v-flex xs12 sm12 md6 lg6 xl6 style="padding:15px;padding-top:0px !important"><!--Seo Form-->
                                    <seo-form FileLoc="CONTENTSEO" :Seo="PageSeo"  @SeoData="SeoChanged"></seo-form>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                      </v-layout>
                  </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
       
        <template><!--Loading Dialog-->
            <div class="vld-parent">
                <loading color="#f75314" :width="parseInt(45)" :height="parseInt(45)" background-color="#fff" :active.sync="isLoading" 
                :is-full-page="true"></loading>
                
               
            </div>
        </template>
    </div>
</template>

<style scoped>
.overFlowHidden .v-dialog:not(.v-dialog--fullscreen)
{
    overflow: hidden !important;
}
.overFlowHidden 
{
    max-width: 400px;
    max-height: 400px;
    overflow: hidden !important;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
}
</style>
<script>
const axios = require("axios");
const ApiUrl = require('../../../constant/apiurl');
const MSGHNDL = require('../../../constant/MessageHandler');
const FTYPES = require('../../../constant/setting/Default/AllowedFileTypes');
const FSIZE = require('../../../constant/setting/Default/AllowedFileSize');
import { mapState, mapMutations, mapActions } from 'vuex'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { VueEditor } from "vue2-editor";
export default {
    name:"contactus",
   components: {
            Loading,
            VueEditor
        },
    data:()=> ({
        CurrentPageName:"ContactUs",
        Lat:0,
        Lng:0,
        ConfirmItemDeleteDialog:false,
        isLoading:false,
        seo:{},
        ALLOEWDIMGSIZE:{},
        CatSeoModel:{},
        inEditingItem:false,
        EditSelectedItem:{},
        EditorContent:"",
        PageSeo:{},
        Socials:[],
        SocialSaved:[]
    }),
    async created()
    {
        let vm = this;
       axios.interceptors.request.use((config) => {
            vm.isLoading = true;
            return config;
        }, (error) => {
            vm.isLoading = false;
            return Promise.reject(error);
        });

        axios.interceptors.response.use((response) => {
            vm.isLoading = false;
            return response;
        }, (error) => {
            vm.isLoading = false;
            return Promise.reject(error);
        });
       await this.loadCategories();
       this.ALLOEWDIMGSIZE = FSIZE.PRDCATIMGSIZE;
    },
    computed:{
        LANG(){
        return this.$store.getters.GetLang;
        }
    },
    watch:{
        LANG(nL,oL){
        this.loadCategories();
        }
    },
    methods:{
         getRand(min = 1000000, max = 90000000000) {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min + 1)) + min;
        },
        Remove(i)
        {
            var vm = this;
            let current = vm.Socials[i];
            vm.Socials.splice(i,1);
        },
        Add(i)
        {
            var vm = this;
            let current = vm.Socials[i];
            vm.Socials.splice(i,0,current);
        },
        ...mapActions([                  // Add this
        'setSeoForm'
        ]),
        LoadSeoFormData()
        {
            let vm = this;

            return vm.seo;
           
        },
        async loadCategories()
        {
            let vm = this;
            vm.EditorContent = "";
            vm.pageSeo = {};
            vm.isLoadingCats = true;
            let Model ={};
            Model.PageName = vm.CurrentPageName;
            Model.Lang = vm.LANG;
            await axios.post(ApiUrl.GetPageContent,Model).then(async (res)=>{
                vm.isLoadingCats = false;
                let data = res.data;
                console.warn(data);
                if(data.status)
                {
                    vm.EditorContent = data.data.pageContent;
                     vm.PageSeo = (JSON.parse(data.data.pageSeo)); 
                    let coord = JSON.parse(data.data.pageOtherSetting);
                    vm.Lat = coord.coord.lat;
                    vm.Lng = coord.coord.lng;
                    vm.Socials = coord.social;
                    await vm.loadSocials();
                }
            }).catch((err)=>{
                vm.isLoadingCats = false;
                console.error(err);
            });
        },
        async loadSocials()
        {
            let vm = this;
            vm.isLoadingCats = true;
            await axios.post(ApiUrl.GetSocialTitles).then(async (res)=>{
                let data = res.data;
                console.warn(data);
                if(data.status)
                {
                   let Social = data.data;
                   let spcial = [];
                   Social.forEach(el => {
                       if(!vm.Socials.some(x=>x.id == el.id))
                       {
                           vm.Socials.push(el);
                       }
                        
                    });
                   
                   console.warn(vm.Socials);
                }
            }).catch((err)=>{
                console.error(err);
            });
        },
        async registerCategory()
        {
            let vm = this;
            let coordinate = {};
            coordinate.lat = vm.Lat;
            coordinate.lng = vm.Lng;
            let Model = {};
            Model.PageName = vm.CurrentPageName;
            Model.PageContent = vm.EditorContent;
            Model.PageId = vm.seo.url;
            Model.PageSeo = JSON.stringify(vm.LoadSeoFormData());
            Model.PageOtherSetting = JSON.stringify({coord:coordinate,social:vm.Socials});
            Model.Lang = vm.LANG;
            await axios.post(ApiUrl.AddPageContent,Model).then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    vm.loadCategories();
                    vm.cancelEditItem();
                    MSGHNDL.OK(data.msg);
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            }).catch((err)=>{console.warn(err)});
        },
        SeoChanged(data)
        {
            this.seo = data;
        }
    }
}
</script>